import { Particle } from "../particle";
import { colorGradient, hold, lerp, linearMotion, randomAngle, randomBetween } from "../interpolation";

export class LargeExplosionParticle extends Particle {
	constructor(originX: number, originY: number) {
		const angle = randomAngle();
		const speed = randomBetween(4.0, 9.0);
		const vx = Math.cos(angle) * speed;
		const vy = Math.sin(angle) * speed;

		super(originX, originY, {
			ttl: randomBetween(350, 600),
			size: lerp(0.5, 0.1),
			opacity: hold(1.0, 0.5, lerp(1.0, 0.0)),
			color: colorGradient([
				{ r: 255, g: 220, b: 50 },
				{ r: 255, g: 120, b: 20 },
				{ r: 80, g: 80, b: 80 },
			]),
			rotation: lerp(0, randomBetween(-2, 2)),
			position: linearMotion(vx, vy),
		});
	}
}
